import React from 'react'
import PureList from 'pureComponents/PureList'
import { PROCESSING_LIST, TASK_STATUS_LIST } from './constants'
import useProcessingList from './hooks/useProcessingList'

const ProcessingList = props => {
    const { state, setState, colRender } = useProcessingList(props)
    return (
        <PureList
            {...state}
            {...setState}
            colRender={colRender}
            columnsConfig={PROCESSING_LIST}
            filterName="channelName"
            searchPlaceholder="渠道包名称"
            filterSelectData={TASK_STATUS_LIST}
        />
    )
}

export default ProcessingList
